import React, { useRef, useState } from "react";
import Findyourterminal from "../../../components/common/commutingservices/Findyourterminal";

const FlightInfo = () => {
  return (
    <div className="m-auto my-[2vw]">
      <h2 className="font-redhatBold text-[5vw] lg:text-[2vw] text-primary text-center">
        Flight Status
      </h2>

      <div className="lg:w-[80%] w-full m-auto mt-[3vw]">
        <Findyourterminal />
      </div>
    </div>
  );
};

export default FlightInfo;
